module.exports = __webpack_public_path__ + "img/donante-dif-tijuana.1ef5bca8.png";